import { ng } from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';

export class PositionIsNotSetDialogComponent {
    public modalInstanceService: ng.ui.bootstrap.IModalInstanceService = this as any;
    public resolve: {
        contentTranslateKey: string
    };

    public ok() {
        this.modalInstanceService.close();
    }
}

angular.module('app.common').component('positionIsNotSetDialogComponent', {
    template: require('./position-is-not-set-dialog.component.html'),
    controller: PositionIsNotSetDialogComponent,
    controllerAs: 'ctrl',
    bindings: {
        resolve: '<',
        close: '&'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/components/google-map/position-is-not-set-dialog/position-is-not-set-dialog.component.ts